import { Link } from 'react-router-dom';
import { SplashCursor } from '../components/ui/SplashCursor';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-theme-light-bg dark:bg-theme-dark-bg relative">
      <SplashCursor
        DENSITY_DISSIPATION={4}
        VELOCITY_DISSIPATION={2.5}
        PRESSURE={0.8}
        SPLAT_RADIUS={0.15}
        COLOR_UPDATE_SPEED={8}
      />
      <div className="text-center relative z-10">
        <h1 className="text-6xl font-bold text-theme-light-text dark:text-theme-dark-text mb-4">
          404
        </h1>
        <h2 className="text-2xl font-semibold text-theme-light-text dark:text-theme-dark-text mb-4">
          Page Not Found
        </h2>
        <p className="text-theme-light-text-secondary dark:text-theme-dark-text-secondary mb-8">
          The page you're looking for doesn't exist or has been updated in the meantime.
        </p>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-2.5 border border-transparent text-base font-medium rounded-md bg-white text-black hover:bg-gray-100 transition-colors duration-200"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
